<template>
  <div class="rich-page">
    <div v-html="content"></div>

<!--    <download />-->
  </div>
</template>

<script>
export default {
  name: 'Rich',
  data() {
    return {
      code: '',
      type: '',

      content: ''
    }
  },
  mounted() {
    this.code = this.$route.query.code
    this.type = this.$route.query.type
    this.init()
  },
  methods: {
    async init() {
      const loading = this.$toast.loading({ message: '加载中' })
      await Promise.all([this.getDetail()])
      loading.clear()
    },

    async getDetail() {
      const response = await this.$request.api.get({ url: this.$api.agreementUrl + this.code })
      const { success, message, code, data } = response

      if (success && code === 200) {
        this.content = data.description || ''
      } else {
        this.$toast.fail(message || '获取详情失败')
      }
    }
  }
}
</script>

<style lang="scss">
.rich-page {
  padding: 20px;
  img {
    max-width: 100%;
  }
}
</style>
